import { Identity } from './Identity';

export class User {
  id?: string;
  displayName?: string;
  givenName?: string;
  surname?: string;
  username?: string;
  preferredName?: string;
  mail?: string;
  mobilePhone?: string;
  country?: string;
  photo?: string;
  userType?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  password?: string;
  streetAddress?: string;
  accountEnabled?: string;
  userPrincipalName?: string;
  identities?: Identity[] = [];
  accountID?: string;
  investCloudUserAttributesCheck?: string;
  investCloudAccountAttributesCheck?:string;
  customAttributes?: Map<string, string>;
  customAttributesUser?: any = {};
  customAttributesAccount?: any = {};
  generateUserToAccountFileFlag?: string;
}
